"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const MapOlModel_1 = __importDefault(require("../Modules/Models/MapOlModel"));
const ModalExportMap_vue_1 = __importDefault(require("../Components/ModalExportMap.vue"));
const MapOlControls_vue_1 = __importDefault(require("../Components/MapOlControls.vue"));
const MapOlFakeData_1 = __importDefault(require("../Modules/Models/MapOlFakeData"));
let MapOl = class MapOl extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isModalDownloadFiles = false;
        this.pointInfoModal = null;
        this.polygonInfoModal = null;
        this.closeModalPolygon = false;
        this.closeModalPoint = false;
        this.isLoadingDownloadFile = false;
        this.isDeployPopUpPoint = true;
        this.counter = 0;
        this.center = this.config.centerMapConfig.center;
    }
    mounted() {
        var _a;
        const test = Object.assign({}, this.config);
        test.tiffUrl = ((_a = this.metricSelected) === null || _a === void 0 ? void 0 : _a.rasterUrl) || undefined;
        this.MAP_CONTROLLER = new MapOlModel_1.default(test);
        this.MAP_CONTROLLER.createMap();
        this.pointInfoModal = this.MAP_CONTROLLER.pointInfo;
        this.polygonInfoModal = this.MAP_CONTROLLER.polygonInfo;
    }
    resetMapCenter() {
        this.MAP_CONTROLLER.resetMap();
    }
    resetMap() {
        this.MAP_CONTROLLER.config = this.config;
        this.MAP_CONTROLLER.resetMap();
        this.isDeployPopUpPoint = false;
    }
    get controlsConfig() {
        const controlsConfig = {
            zoom: this.isZoomControl,
            center: this.isCenterControl,
            fullScreen: this.isFullScreenControl,
            download: this.isDownloadControl,
        };
        return controlsConfig;
    }
    centerMapPolygonSelect(geometry) {
        this.MAP_CONTROLLER.focus();
    }
    setPointInfo() {
        this.closeModalPoint = !this.closeModalPoint;
        this.counter += 1;
        this.isDeployPopUpPoint = true;
        this.pointInfoModal = this.MAP_CONTROLLER.pointInfo;
        this.$emit('pointSelectInfo', this.pointInfoModal);
    }
    setPolygonInfo() {
        this.polygonInfoModal = this.MAP_CONTROLLER.pointInfo;
        this.closeModalPolygon = false;
        this.$emit('poilygonSelectInfo', this.polygonInfoModal);
    }
    minusZoom() {
        this.MAP_CONTROLLER.zoomOut();
    }
    moreZoom() {
        this.MAP_CONTROLLER.zoomIn();
    }
    centerMap() {
        this.MAP_CONTROLLER.focus();
        this.closeModalPolygon = true;
        this.closeModalPoint = true;
    }
    fullScreen() {
        this.MAP_CONTROLLER.fullScreen();
    }
    hasSampleView(isSamples) {
        this.MAP_CONTROLLER.isSamplesView(isSamples);
    }
    downloadFiles(ext) {
        this.isLoadingDownloadFile = true;
        this.MAP_CONTROLLER.download(ext);
        setTimeout(() => {
            this.isLoadingDownloadFile = false;
        }, 1500);
    }
    deployModalDownloadFiles() {
        this.isModalDownloadFiles = true;
    }
    dismissModalDownloadFiles() {
        this.isModalDownloadFiles = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'bottom-end' })
], MapOl.prototype, "controlsPosition", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'bmfw-conector-view-map-ol' })
], MapOl.prototype, "connectorMapId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'bmfw-tooltip-point' })
], MapOl.prototype, "pointsConnectorId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: MapOlFakeData_1.default })
], MapOl.prototype, "config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true })
], MapOl.prototype, "isControlsMap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true })
], MapOl.prototype, "isZoomControl", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true })
], MapOl.prototype, "isCenterControl", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true })
], MapOl.prototype, "isFullScreenControl", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true })
], MapOl.prototype, "isDownloadControl", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'bmfw-tooltip-point-button-id' })
], MapOl.prototype, "tooltipPointButtonId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: { provider: 'OpenStreetMaps', apikey: null } })
], MapOl.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapOl.prototype, "metricSelected", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('config.centerMapConfig.center')
], MapOl.prototype, "resetMapCenter", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('config')
], MapOl.prototype, "resetMap", null);
MapOl = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ModalExportMap: ModalExportMap_vue_1.default,
            MapOlControls: MapOlControls_vue_1.default,
        },
    })
], MapOl);
exports.default = MapOl;
